<template>
    <div class="draftBox">
        <avue-crud :data="data" :option="option" :page.sync="page" @current-change="changePage"  @selection-change="selectionChange">
            <template slot="menuBtn" slot-scope="scope">
                <el-dropdown-item class="pull-down" @click.native="useDraftBtn(scope.row)">使用</el-dropdown-item>
                <el-dropdown-item class="pull-down" @click.native="deleteDraftBtn(scope.row)">删除</el-dropdown-item>
            </template>
            <template slot="menuLeft"  slot-scope="scope" >
                <el-button  class="View" @click="draftBtn">批量删除草稿</el-button>
            </template>
        </avue-crud>
    </div>
</template>

<script>
    import { deleteDraft, deleteManuscript, draftList } from '../../api/templateList';

    export default {
        name: 'draftBox',
        inject: ['reload'],
        data() {
            return {
                page: {
                    currentPage: 1,
                    total: 10,  //总数
                    pageSize: 10 //每页多少
                },
                data: [],
                pages:1,
                option:{
                    menuType: 'menu',
                    menuBtnTitle:'操作',
                    selection: true, //批量选择
                    stripe:true,
                    addBtn:false,  //新增按钮
                    align:'center',  //文本居中
                    menuAlign:'center', //操作栏居中
                    columnBtn:false,  //列动态显隐按钮
                    refreshBtn:false,  //刷新按钮
                    editBtn:false,  //编辑按钮
                    delBtn:false,  //删除按钮
                    menuWidth:150,  //操作栏宽度设置
                    column:[
                        {
                            label:'模板名称',
                            prop:'tpl_name'
                        }, {
                            label:'备注',
                            prop:'notes'
                        },  {
                            label: '更新时间',
                            prop: 'update_time'
                        }
                    ]
                },
            };
        },
        methods:{
            //批量操作
            selectionChange(list){
                this.ids = []
                list.forEach(res=>{
                    this.ids.push(res.id)
                })
            },
            changePage(num){
                draftList(10,num).then(res=>{
                    if (res.code==200){
                        sessionStorage.setItem('draftBox',num)
                        this.data=res.data.list
                        this.page.total=res.data.count
                    }
                })
            },
            //使用草稿模板
            useDraftBtn(row){
                this.$router.push({path:'/manuscriptPage',query:{id:row.id,templateId:row.tpl_auth_id}})
            },
            //删除草稿模板
            deleteDraftBtn(row){
                deleteManuscript(row.id).then(res=>{
                    if (res.code==200){
                        this.$message.success(res.msg)
                        this.reload()
                    }else {
                        this.$message.error(res.msg)
                    }
                })
            },
            //批量删除草稿
            draftBtn(){
                if (this.ids==undefined||this.ids==''){
                    this.$message.error('请选择草稿');
                }else {
                    this.$confirm('请确认是否批量删除草稿 ', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        deleteDraft({draft_ids:this.ids}).then(res=>{
                            if (res.code==200){
                                this.$message.success(res.msg)
                                this.reload()
                            }else {
                                this.$message.error(res.msg)
                            }
                        })

                    }).catch(() => {

                    });
                }
            }
        },
        created() {
            if (sessionStorage.getItem('draftBox')===null){
                draftList(10,this.pages).then(res=>{
                    if (res.code==200){
                        this.data=res.data.list
                        this.page.total=res.data.count
                        this.page.currentPage=1
                    }
                })
            }else {
                draftList(10,sessionStorage.getItem('draftBox')).then(res=>{
                    if (res.code==200){
                        this.data=res.data.list
                        this.page.total=res.data.count
                        this.page.currentPage=sessionStorage.getItem('draftBox')
                    }
                })
            }

        }
    };
</script>

<style scoped>
    .draftBox{
        padding: 20px;
        background-color: #fff;
        border-radius: 5px;
    }
    .customize{
        background-color: #3e62f6;
        color: #fff;
    }
    /deep/.el-dropdown-link {
        cursor: pointer;
        color: #409EFF;
    }
    /deep/.el-icon-arrow-down {
        font-size: 15px;
    }
    .pull-down{
        padding: 5px 30px !important;
    }
    .View{
        background-color: #3e62f6;
        color: #ffffff;
    }
</style>
